<div class="dialog__body dialog__body--consult">
  <!-- 連絡事項 -->
  <div class="az-consult__contact">
    <h3 class="az-consult__contact-title">連絡事項</h3>
    <textarea
      class="az-consult__contact-textarea"
      [(ngModel)]="contactNote"
      placeholder="連絡事項を入力してください"
    ></textarea>
  </div>

  <!-- 相談したい項目 / 相談したい内容 -->
  <div class="az-consult__columns">
    <h3 class="az-consult__column-title">相談したい項目</h3>
    <h3 class="az-consult__column-title">相談したい内容</h3>
  </div>

  <div class="az-consult__item" *ngFor="let row of getConsultationRows()">
    <div class="az-consult__target">
      <div
        class="az-consult__alert"
        [class.az-consult__alert--error]="jobAzCheckService.getError(row.fieldKey) && jobAzCheckService.getError(row.fieldKey).type === 'error'"
        [class.az-consult__alert--warning]="jobAzCheckService.getError(row.fieldKey) && jobAzCheckService.getError(row.fieldKey).type === 'warning'"
      >
        {{ jobAzCheckService.getError(row.fieldKey)?.message }}
      </div>
      <div class="az-consult__form-area">
        <div class="az-consult__row-title" *ngIf="getConsultationRowLabelOverride(row) as rowLabel">{{ rowLabel }}</div>
        <ag-dynamic-form
          [metadata]="getConsultFormMeta(row)"
          [model]="row.useCompanyModel ? jobAzCheckService.companyData : jobAzCheckService.job"
        ></ag-dynamic-form>
      </div>
    </div>
    <div class="az-consult__content">
      <textarea
        class="az-consult__content-textarea"
        [(ngModel)]="consultationContents[row.fieldKey]"
        placeholder="相談したい内容を入力してください"
      ></textarea>
    </div>
  </div>

  <div class="az-consult__item" *ngFor="let detail of getWageConsultationDetails()">
    <div class="az-consult__target">
      <div class="az-consult__alert az-consult__alert--error">
        {{ detail.message }}
      </div>
      <div class="az-consult__form-area">
        <table class="az-consult__wage-table">
          <tr class="az-consult__wage-table-row" *ngFor="let item of getWageConsultationFieldItems(detail)">
            <th class="az-consult__wage-table-label">{{ item.label }}</th>
            <td class="az-consult__wage-table-value">{{ item.value }}</td>
          </tr>
        </table>
      </div>
    </div>
    <div class="az-consult__content">
      <textarea
        class="az-consult__content-textarea"
        [(ngModel)]="consultationContents[detail.field]"
        placeholder="相談したい内容を入力してください"
      ></textarea>
    </div>
  </div>

  <p class="az-consult__empty" *ngIf="!getConsultationRows().length && !getWageConsultationDetails().length">
    相談したい項目が選択されていません。
  </p>
</div>
